export default function Card({ title, subtitle, action, children, className = "", testid, padding = "p-5 md:p-6" }) {
  return (
    <div
      data-testid={testid}
      className={`studio-surface rounded-[1.35rem] ${padding} ${className}`}
    >
      {(title || action) && (
        <div className="flex items-start justify-between gap-3 mb-4 flex-wrap">
          <div className="min-w-0">
            {title && <div className="font-display font-semibold text-[15px] sm:text-[16px] tracking-tight text-[#1C1C1E]">{title}</div>}
            {subtitle && <div className="text-[11.5px] sm:text-[12px] text-[#8E8E93] mt-0.5">{subtitle}</div>}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
